import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEye } from "react-icons/fa";
import {
  Layout,
  Row,
  Col,
  Card,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Table,
  Empty,
} from "antd";

import { getUsers } from "../features/cutomers/customerSlice";
import { getStates } from "../features/statecity/statecitySlice";
import { getClusters } from "../features/cluster/clusterSlice";
import {
  getPayment,
  createPayment,
  updateAPayment,
  resetState,
} from "../features/payments/paymentSlice";
import { formatDate } from "../utils/dateHelper";
// import locale from 'antd/locale/en_US';
import dayjs from "dayjs";
import "dayjs/locale/en-in";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("en-in");
dayjs.tz.setDefault("Asia/Kolkata");

const { Content } = Layout;
const { Option } = Select;

const PaymentRecords = () => {
  const dispatch = useDispatch();
  const [selectedState, setSelectedState] = useState("");
  const [vcData, setVcData] = useState([]);
  // const [vtData, setvtData] = useState([]);
  // const [selectedVC, setselectedVC] = useState("");

  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(getStates());
    dispatch(getClusters());
    dispatch(getUsers());
    dispatch(getPayment());
  }, [dispatch]);

  const handleStateChange = (value) => {
    setSelectedState(value);
    const vcFilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setVcData(vcFilterData);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        values.invoice_date = values.invoice_date.tz("Asia/Kolkata").format(); // Convert to IST
        dispatch(createPayment(values));
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
      });
  };

  const statelistState = useSelector((state) => state.statecity.statelist);
  const clusterlistState = useSelector((state) => state.cluster.cluster);
  const vclistState = useSelector((state) => state.customer.customers);
  const paymentState = useSelector((state) => state.payment);

  const { isSuccess, isError, createdPayment } = paymentState;

  useEffect(() => {
    if (isSuccess && createdPayment) {
      toast.dismiss();
      toast.success("Payment Added Successfully!", { autoClose: 5000 });
      dispatch(getPayment());
      form.resetFields();
    }

    if (isError) {
      toast.dismiss();
      toast.error("An error occurred. Please try again.", { autoClose: 5000 });
    }
  }, [isSuccess, isError, createdPayment, dispatch, form]);

  return (
    <Card title="Payment Records" style={{ marginBottom: 16, padding: "10px" }}>
      <Form form={form} layout="inline">
        <Form.Item
          name="state"
          rules={[{ required: true, message: "Please select a state!" }]}
        >
          <Select
            placeholder="Select State"
            onChange={handleStateChange}
            value={selectedState}
          >
            {statelistState.map((state) => (
              <Option key={state.code} value={state.code}>
                {state.state_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="cluster">
          <Select
            placeholder="Select Cluster"
            style={{ width: 150, marginBottom: 16 }}
          >
            {clusterlistState.map((cluster) => (
              <Option key={cluster._id} value={cluster._id}>
                {cluster.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="vc_name"
          rules={[{ required: true, message: "Please select a VC!" }]}
        >
          <Select
            placeholder="Select VC"
            style={{ width: 150, marginBottom: 16 }}
            value={form.getFieldValue("vc_name")}
          >
            {vcData
              .filter((item) => item.role === "vc")
              .map((vc) => (
                <Option key={vc._id} value={vc._id}>
                  {vc.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="invoice_date"
          rules={[
            { required: true, message: "Please select an invoice date!" },
          ]}
        >
          <DatePicker
            placeholder="Invoice Date"
            style={{ width: 150, marginBottom: 16 }}
          />
        </Form.Item>
        <Form.Item
          name="invoice_no"
          rules={[
            { required: true, message: "Please enter an invoice number!" },
          ]}
        >
          <Input
            placeholder="Invoice No."
            style={{ width: 150, marginBottom: 16 }}
          />
        </Form.Item>
        <Form.Item
          name="invoice_amount"
          rules={[
            { required: true, message: "Please enter an invoice amount!" },
          ]}
        >
          <Input
            placeholder="Invoice Amount"
            style={{ width: 150, marginBottom: 16 }}
          />
        </Form.Item>
        <Form.Item
          name="courier_company"
          rules={[
            { required: true, message: "Please enter a courier company!" },
          ]}
        >
          <Input
            placeholder="Courier Company"
            style={{ width: 150, marginBottom: 16 }}
          />
        </Form.Item>
        <Form.Item
          name="consignment_no"
          rules={[
            { required: true, message: "Please enter a consignment number!" },
          ]}
        >
          <Input
            placeholder="Consignment No."
            style={{ width: 150, marginBottom: 16 }}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

const formatPaymentData = (paymentlistState) => {
  if (!Array.isArray(paymentlistState)) return [];
  return paymentlistState.map((item, index) => ({
    ...item,
    key: index,
    formatvcname: item.userDetails?.name || "",
    formattedAmount: `₹${item.invoice_amount}`,
    formattedInvoiceDate: item.invoice_date
      ? formatDate(item.invoice_date)
      : "",
    formattedRecivedDate: item.received_date
      ? formatDate(item.received_date)
      : "",
    formattedSubmittedDate: item.submitted_date
      ? formatDate(item.submitted_date)
      : "",
  }));
};

const PaymentStatus = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const paymentlistState = useSelector((state) => state.payment.payments);
  const [dataSource, setDataSource] = useState([]);
  const [vtData, setvtData] = useState([]);
  const [selectedVC, setselectedVC] = useState("");
  const [selectedState, setSelectedState] = useState("");

  const paymentUpdateState = useSelector((state) => state.payment);

  const { isSuccess, isError, updatedPayment } = paymentUpdateState;

  useEffect(() => {
    if (Array.isArray(paymentlistState) && paymentlistState.length > 0) {
      const formattedData = formatPaymentData(paymentlistState);
      setDataSource(formattedData);
    } else {
      setDataSource([]);
    }
  }, [paymentlistState]);

  const handleInputChange = (key, field, value) => {
    const newData = dataSource.map((item) => {
      if (item.key === key) {
        return { ...item, [field]: value };
      }
      return item;
    });
    setDataSource(newData);
  };

  const handleSave = (key) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => key === item.key);
    if (index > -1) {
      const item = newData[index];
      const data = {
        id: item._id,
        tds: item.tds,
        penalty: item.penalty,
        remarks: item.remarks,
      };
      dispatch(updateAPayment(data));
      dispatch(resetState());
    }
  };

  useEffect(() => {
    if (isSuccess && updatedPayment) {
      toast.dismiss();
      toast.success("Record Updated Successfully!", { autoClose: 5000 });
      dispatch(getPayment());
    }
    if (isError) {
      toast.dismiss();
      toast.error("An error occurred. Please try again.", { autoClose: 5000 });
    }
  }, [isSuccess, isError, updatedPayment, dispatch]);

  const handleVcChange = (value) => {
    const vtfilterData = vclistState.filter(
      (customer) => customer.vcuser_id === value
    );

    setselectedVC(value);
  };
  const [vcData, setvcData] = useState([]);

  const handleStateChange = (value) => {
    const vcfilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setvcData(vcfilterData);
    setSelectedState(value);
  };

  const statelistState = useSelector((state) => state.statecity.statelist);
  const vclistState = useSelector((state) => state.customer.customers);

  const columns = [
    { title: "State", dataIndex: "state", key: "state", width: 100 },
    {
      title: "Invoice No",
      dataIndex: "invoice_no",
      key: "invoice_no",
      width: 100,
    },
    {
      title: "Invoice Date",
      dataIndex: "formattedInvoiceDate",
      key: "formattedInvoiceDate",
      width: 100,
    },
    {
      title: "VC Name",
      dataIndex: "formatvcname",
      key: "formatvcname",
      width: 100,
    },
    {
      title: "Amount",
      dataIndex: "formattedAmount",
      key: "formattedAmount",
      width: 100,
    },
    {
      title: "Received On",
      dataIndex: "formattedRecivedDate",
      key: "formattedRecivedDate",
      width: 100,
    },
    {
      title: "Submitted On",
      dataIndex: "formattedSubmittedDate",
      key: "formattedSubmittedDate",
      width: 100,
    },
    {
      title: "Submitted To",
      dataIndex: "submitted",
      key: "submitted",
      width: 100,
    },
    {
      title: "Contact No",
      dataIndex: "contact_no",
      key: "contact_no",
      width: 100,
    },
    {
      title: "Recieved Payment",
      dataIndex: "amount_recived",
      key: "amount_recived",
      width: 100,
      // render: (text, record) => (
      //   <Input value={text} onChange={(e) => handleInputChange(record.key, 'invoice_amount', e.target.value)} />
      // )
    },
    {
      title: "TDS",
      dataIndex: "tds",
      key: "tds",
      width: 100,
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) => handleInputChange(record.key, "tds", e.target.value)}
        />
      ),
    },
    {
      title: "Penalty",
      dataIndex: "penalty",
      key: "penalty",
      width: 100,
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) =>
            handleInputChange(record.key, "penalty", e.target.value)
          }
        />
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      width: 100,
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) =>
            handleInputChange(record.key, "remarks", e.target.value)
          }
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "submitsave",
      key: "submitsave",
      width: 100,
      render: (text, record) =>
        record.markstatus ? (
          <Button type="primary" disabled>
            Updated
          </Button>
        ) : (
          <Button type="primary" onClick={() => handleSave(record.key)}>
            Update
          </Button>
        ),
    },
  ];

  const handleSearch = (values) => {
    console.log(
      "Print all 2 Filter Query Data ---",
      selectedState + " " + selectedVC
    );
    const filteredData = paymentlistState.filter((payment) => {
      const matchesState = selectedState
        ? payment.state === selectedState
        : true;
      const matchesVC = selectedVC
        ? payment.userDetails._id === selectedVC
        : true;

      return matchesState && matchesVC;
    });

    if (filteredData.length === 0) {
      toast.error("No payment records found for the selected criteria!");
    }

    setDataSource(formatPaymentData(filteredData));
  };

  const handleClear = () => {
    form.resetFields();
    setSelectedState("");
    setselectedVC("");
    setDataSource(formatPaymentData(paymentlistState));
    setvcData([]);
    setvtData([]);
  };

  return (
    <Card title="Payment Status">
      <Form
        layout="inline"
        style={{ marginBottom: "20px" }}
        onFinish={handleSearch}
      >
        <Form.Item
          name="state_name"
          rules={[
            {
              required: true,
              message: "Please Select State!",
            },
          ]}
        >
          <Select
            style={{ width: 160 }}
            placeholder="Select State"
            onChange={handleStateChange}
          >
            <Select.Option key="default" value="">
              Select State
            </Select.Option>
            {statelistState.map((i, j) => (
              <option key={j} value={i.code}>
                {i.state_name}
              </option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="state_vc">
          <Select
            style={{ width: 160 }}
            placeholder="Select VC"
            onChange={handleVcChange}
          >
            <Select.Option key="default" value="">
              Select VC
            </Select.Option>
            {vcData
              .filter((item) => item.role === "vc")
              .map((item) => (
                <Select.Option key={item._id} value={item._id}>
                  {item.name}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button
            style={{ marginRight: 20, backgroundColor: "#a7b54d" }}
            type="primary"
            htmlType="submit"
          >
            <FaEye /> &nbsp; Search
          </Button>
        </Form.Item>

        <Form.Item>
          <Button type="default" onClick={handleClear}>
            Clear
          </Button>
        </Form.Item>
      </Form>

      {dataSource.length > 0 ? (
        <Table
          className="custom-table"
          columns={columns}
          dataSource={dataSource}
          pagination={{ pageSize: 20 }}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          scroll={{ y: 500 }}
        />
      ) : (
        <Empty description="No payment records found" />
      )}
    </Card>
  );
};

const Payments = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Layout style={{ backgroundColor: "#eaedf2", minHeight: "100vh", fontFamily: "Poppins, sans-serif" }}>
      <Content style={{ padding: isMobile ? "12px" : "20px 24px", backgroundColor: "#eaedf2" }}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <PaymentRecords />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <PaymentStatus />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default Payments;
